import React, { createContext, useContext, useReducer } from "react";
import { ActionContextLightbox } from "./ActionContextLightbox";
import { actionReducer } from "./reducer";
import { ActionStateContext, initialState } from "./action-state";
export const useActionState = () => useContext(ActionStateContext);
export const ActionDispatcherContext = createContext(null);
export const ActionContextProvider = ({ children }) => {
    const [state, dispatchAction] = useReducer(actionReducer, initialState);
    return (React.createElement(ActionDispatcherContext.Provider, { value: { dispatchAction } },
        React.createElement(ActionStateContext.Provider, { value: state },
            children,
            React.createElement(ActionContextLightbox, null))));
};
//# sourceMappingURL=context.js.map